import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import formatDate from '@/services/general/formatIsoDate';

export default function transformer(serverTableData) {
  if (serverTableData.query.dates.dateDebut) {
    serverTableData.query.dates.dateDebut = formatDate(
      serverTableData.query.dates.dateDebut,
    );
  }
  if (serverTableData.query.dates.dateFin) {
    serverTableData.query.dates.dateFin = formatDate(
      serverTableData.query.dates.dateFin,
    );
  }
  if (serverTableData.orderBy === 'theme') {
    serverTableData.orderBy = 'facture.theme';
  }
  if (serverTableData.orderBy === 'codeDossier') {
    serverTableData.orderBy = 'facture.codeDossier';
  }
  if (serverTableData.orderBy === 'dateEcheance') {
    serverTableData.orderBy = 'facture.DateDevisCommande';
  }
  if (serverTableData.orderBy === 'nomCommercial') {
    serverTableData.orderBy = 'facture.nomCommercial';
  }
  if (serverTableData.orderBy === 'codeFacture') {
    serverTableData.orderBy = 'facture.referenceClient';
  }
  if (serverTableData.orderBy === 'motifBlocage') {
    serverTableData.orderBy = 'tiers.motifBlocage.libelle';
  }
  if (serverTableData.orderBy === 'blocageReglement') {
    serverTableData.orderBy = 'tiers.blocageReglement';
  }
  return generalTransformer(serverTableData);
}
